module.exports = __webpack_public_path__ + "img/pexels-ekaterina-bolovtsova-5263829.8bcf0e46.jpg";